/**
 * Bottle Personalization - Preview en vivo, precio automático, selección de fuente
 * Para productos con tag 'personalizable'
 */
(function() {
  'use strict';

  function initBottlePersonalization() {
    var containers = document.querySelectorAll('[data-personalization]');
    if (!containers.length) return;

    containers.forEach(function(container) {
      var sectionId = container.dataset.sectionId;
      var productId = container.dataset.productId;
      var basePrice = parseInt(container.dataset.basePrice, 10) || 0;
      var personalizationPrice = parseInt(container.dataset.personalizationPrice, 10) || 2990;
      var variantPersonalizadoId = container.dataset.variantPersonalizadoId || null;
      var maxChars = parseInt(container.dataset.maxChars, 10) || 12;

      var input = container.querySelector('[data-personalization-input]');
      var fontSelect = container.querySelector('[data-personalization-font]');
      var charsEl = container.querySelector('[data-personalization-chars]');

      var productSection = document.getElementById('ProductSection-' + sectionId + '-' + productId);
      var previewEl = productSection ? productSection.querySelector('[data-personalization-preview-text]') : null;
      var priceEl = productSection ? productSection.querySelector('[data-product-price]') : null;
      var form = productSection ? productSection.querySelector('.product-single__form') : null;
      var variantSelect = form ? form.querySelector('[data-product-select]') : null;

      if (!input) return;

      function updateChars() {
        var len = (input.value || '').length;
        var left = maxChars - len;
        if (charsEl) {
          charsEl.textContent = left > 0 ? left + ' caracteres disponibles' : '0 caracteres disponibles';
        }
      }

      function getFontFamily() {
        if (!fontSelect) return "'Bebas Neue', sans-serif";
        var opt = fontSelect.options[fontSelect.selectedIndex];
        return (opt && opt.dataset.fontFamily) ? opt.dataset.fontFamily : "'Bebas Neue', sans-serif";
      }

      function updatePreview() {
        var text = (input.value || '').trim();
        if (previewEl) {
          previewEl.textContent = text;
          previewEl.style.fontFamily = getFontFamily();
          var overlay = previewEl.closest('[data-personalization-preview]');
          if (overlay) overlay.style.visibility = text ? 'visible' : 'hidden';
        }
      }

      function updatePriceAndVariant() {
        var text = (input.value || '').trim();
        var isPersonalized = text.length > 0;

        if (priceEl && window.theme && theme.Currency && theme.settings) {
          var displayPrice = isPersonalized ? basePrice + personalizationPrice : basePrice;
          priceEl.innerHTML = theme.Currency.formatMoney(displayPrice, theme.settings.moneyFormat);
        }

        if (variantSelect && variantPersonalizadoId && isPersonalized) {
          var variantExists = Array.from(variantSelect.options).some(function(opt) {
            return opt.value === String(variantPersonalizadoId);
          });
          if (variantExists) {
            variantSelect.value = variantPersonalizadoId;
          }
        } else if (variantSelect && !isPersonalized) {
          var baseId = container.dataset.baseVariantId;
          if (baseId) {
            var baseOpt = Array.from(variantSelect.options).find(function(o) { return o.value === baseId; });
            if (baseOpt) variantSelect.value = baseId;
          }
        }
      }

      function handleChange() {
        updateChars();
        updatePreview();
        updatePriceAndVariant();
      }

      input.addEventListener('input', handleChange);
      input.addEventListener('change', handleChange);
      if (fontSelect) {
        fontSelect.addEventListener('change', function() {
          updatePreview();
        });
      }

      var baseVariantId = container.dataset.baseVariantId;
      document.addEventListener('variant:change', function(evt) {
        var v = evt.detail && evt.detail.variant;
        if (v && v.price && String(v.product_id) === String(productId)) {
          basePrice = v.price;
          baseVariantId = String(v.id);
          container.dataset.basePrice = basePrice;
          container.dataset.baseVariantId = baseVariantId;
          handleChange();
        }
      });

      updateChars();

      if (form) {
        form.addEventListener('submit', function(evt) {
          var text = (input.value || '').trim();
          if (text && variantPersonalizadoId && variantSelect) {
            var variantExists = Array.from(variantSelect.options).some(function(opt) {
              return opt.value === String(variantPersonalizadoId);
            });
            if (variantExists) {
              variantSelect.value = variantPersonalizadoId;
            }
          }
        }, true);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBottlePersonalization);
  } else {
    initBottlePersonalization();
  }

  document.addEventListener('shopify:section:load', initBottlePersonalization);
})();
